
const maxSize = 300 * 1024 * 1024; // 300MB
const fileTypesByCrm = JSON.parse(localStorage.getItem('BOPLFT'));
const validMimetypes = fileTypesByCrm.mimetypes;
const acceptTypes = fileTypesByCrm.validTypes;

const validTypes = Object.entries(fileTypesByCrm.names)
  .reduce((acc, x) => {
    acc = `${acc}, ${x[0]}`;
    return acc;
  }, '')
  .substr(1);
/**
 * Obtiene el tipo de fichero a partir del nombre
 * @param {String} name Nombre del fichero
 * @return {String} tipo de fichero
 */
const resolveFileType = function(name) {
  return Object.entries(fileTypesByCrm.names).reduce((acc, [key, pattern]) => {
    if (acc) return acc; // Si ya encontramos una coincidencia, la devolvemos
    const regex = new RegExp(pattern, 'i'); // Convertimos la cadena en expresión regular
    if (regex.test(name)) return key; // Si coincide, devolvemos la clave (tipo de archivo)
    return acc; // Si no coincide, continuamos con la búsqueda
  }, null);
};
export default {
  name: 'import-file',
  data() {
    return {
      selectedFiles: null,
      uploading: [],
      progress: 0,
      max: 1,
      acceptTypes
    };
  },
  props: {
    inProgress: {
      type: Array,
      require: false,
      default: []
    }
  },
  computed: {
    areSelectedFiles: {
      get() {
        return this.selectedFiles && this.selectedFiles.length > 0;
      }
    },
    isUploading() {
      return this.uploading && this.uploading.length > 0;
    }
  },
  methods: {
    /**
     * @override
     */
    autoUploadFileByName() {
      try {
        const selectedFiles = [...this.$refs.filesRef.files];
        selectedFiles.forEach(file => {
          if (file.size >= maxSize) {
            const err = new Error(`El fichero "${file.name}" supera el tamaño máximo permitido (300MB).`);
            err.name = 'MaxSizeError';
            throw err;
          }

          if (!validMimetypes.includes(file.type)) {
            const err = new Error(
              `El fichero "${file.name}" posee un mimetype desconocido. Solo se aceptan ficheros de texto o XML.`
            );
            err.name = 'UnknownMimetypeError';
            throw err;
          }

          file.fileType = resolveFileType(file.name);
          if (!file.fileType) {
            const err = new Error(
              `No se pudo determinar el tipo del fichero "${file.name}". Tipos válidos: ${validTypes}.`
            );
            err.name = 'UnknownFiletypeError';
            throw err;
          }
          const fileTypeLiteral = this.$t(`importer.file_types.${file.fileType}`);
          if (this.uploading.includes(file.fileType)) {
            const err = new Error(`Se ha seleccionado más de un fichero de tipo "${fileTypeLiteral}".`);
            err.name = 'DuplicatedFiletypeError';
            throw err;
          }
          if (this.inProgress.includes(file.fileType)) {
            const err = new Error(`Ya se está importando un fichero de tipo "${fileTypeLiteral}".`);
            err.name = 'InProgressFiletypeError';
            throw err;
          }
          this.uploading.push(file.fileType);
        });
        this.progress = 0;
        this.max = this.uploading.length;
        selectedFiles.forEach(file => this.uploadFile(file));
      } catch (err) {
        this.uploading = [];
        const errTitle = this.$t(`importer.errors.${err.name}`);
        this.$toast.error(errTitle, err.message);
      }

      setTimeout(() => (this.$refs.filesRef.value = null), 500);
    },
    /**
     * Upload file
     * @param {File} file file
     */
    uploadFile(file) {
      const reader = new FileReader();
      const filetype = file.fileType;
      reader.readAsText(file);
      reader.onload = () => {
        this.progress += 0.5;
        const data = {
          type: filetype,
          attachment: file
        };

        this.$importService.upload(data, this).then(res => {
          this.progress += 0.5;
          setTimeout(() => {
            this.uploading = this.uploading.filter(x => x !== filetype);
            this.$emit('change', res);
          }, 500);
        })
        .catch(error => {
          this.progress = 0;
          this.uploading = [];
          const errTitle = error.name;
          this.$toast.error(errTitle, error.detail ? error.detail : 'Ha ocurrido un error desconocido.');
        });
      };
    }
  }
};
